import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import OrderItemListMenu from '../../commons/orderItmesListMenu';
import useMobileTabState from '../ScanpackScanning/hooks/useMobileTabState';
import {selectFocusedOrder} from '../../actions/ScanToCartScanningActions';
import UnScannedItemsList from './UnScannedItems';
import ScannedItemsList from './ScannedItemList';
import {filterItemsByOrderId, getScannedPieceCount, getUnscannedPieceCount} from './utils/scanningUtils';

const PANE_STYLE = {backgroundColor: '#4A6179'};

// Mounted with key={focusedOrderId} so every focus opens on Unscanned
const FocusedListTabs = () => {
  const focusedOrderId = useSelector(selectFocusedOrder)?.id ?? null;
  const unScannedItems = useSelector(state => state.scanToCart.unScannedItems);
  const scannedItems = useSelector(state => state.scanToCart.scannedItems);
  // useMobileTabState names are inverted: scannedList === true means the Unscanned tab is showing
  const {scannedList: unscannedTabActive, showScannedListTab, showUnScannedListTab} = useMobileTabState();

  return (
    <>
      <View testID="focusListTabs" style={{order: 1}}>
        <OrderItemListMenu
          showScannedList={showScannedListTab}
          showUnScannedList={showUnScannedListTab}
          unScannedCount={getUnscannedPieceCount(filterItemsByOrderId(unScannedItems, focusedOrderId))}
          scannedCount={getScannedPieceCount(filterItemsByOrderId(scannedItems, focusedOrderId))}
          scannedList={unscannedTabActive}
          unScannedList={!unscannedTabActive}
          showActivityLog={false}
          showNavButton={false}
        />
      </View>
      {unscannedTabActive ? (
        <View testID="unscannedPane" style={{...PANE_STYLE, order: 2}}>
          <UnScannedItemsList />
        </View>
      ) : (
        <View testID="scannedPane" style={{...PANE_STYLE, order: 2}}>
          <ScannedItemsList />
        </View>
      )}
    </>
  );
};

export default FocusedListTabs;
